import { FovErrorType, FovErrorOption, FovPageType, FovErrorExperience, HttpMethods, FovErrorStatusOptions, } from '@contentsquare/fov-constants';
export const errorCondition = {
    id: 'error',
    category: 'conditions',
    value: {
        errorOptions: [
            {
                value: { errorType: FovErrorType.JS, errorOption: FovErrorOption.ANY },
                label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.ANY_JS_ERRORS',
            },
            {
                value: { errorType: FovErrorType.JS, errorOption: FovErrorOption.NAMED },
                label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.NAMED_JS_ERRORS',
            },
            {
                value: { errorType: FovErrorType.JS, errorOption: FovErrorOption.EXACT },
                label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.EXACT_JS_ERRORS',
            },
            {
                value: { errorType: FovErrorType.JS, errorOption: FovErrorOption.GROUPED },
                label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.GROUPED_JS_ERRORS',
            },
            {
                value: { errorType: FovErrorType.API, errorOption: FovErrorOption.ANY },
                label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.ANY_API_ERRORS',
            },
            {
                value: { errorType: FovErrorType.API, errorOption: FovErrorOption.NAMED },
                label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.NAMED_API_ERRORS',
            },
            {
                value: { errorType: FovErrorType.API, errorOption: FovErrorOption.EXACT },
                label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.EXACT_API_ERRORS',
            },
            {
                value: { errorType: FovErrorType.API, errorOption: FovErrorOption.GROUPED },
                label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.GROUPED_API_ERROR',
            },
        ],
        pageOptions: [
            {
                value: FovPageType.ANY,
                label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.SELECT_ANY_PAGE',
            },
            {
                value: FovPageType.PAGE,
                label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.SELECT_SPECIFIC_PAGE',
            },
            {
                value: FovPageType.URL,
                label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.SELECT_SPECIFIC_URL',
            },
        ],
        errorExperienceOptions: [
            {
                value: FovErrorExperience.EXPERIENCED,
                label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.EXPERIENCED',
            },
            {
                value: FovErrorExperience.HAVE_NOT_EXPERIENCED,
                label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.HAVE_NOT_EXPERIENCED',
            },
        ],
        httpMethods: [
            { value: HttpMethods.GET, label: HttpMethods.GET },
            { value: HttpMethods.POST, label: HttpMethods.POST },
            { value: HttpMethods.PUT, label: HttpMethods.PUT },
            { value: HttpMethods.PATCH, label: HttpMethods.PATCH },
            { value: HttpMethods.DELETE, label: HttpMethods.DELETE },
        ],
        errorStatusOptions: [
            {
                value: FovErrorStatusOptions.ALL,
                label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.STATUS.ALL',
            },
            {
                value: FovErrorStatusOptions.DISMISSED,
                label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.STATUS.DISMISSED',
            },
            {
                value: FovErrorStatusOptions.UNDISMISSED,
                label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.STATUS.UNDISMISSED',
            },
        ],
    },
};
//# sourceMappingURL=error-condition.value.js.map